import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Project, ProjectSlug } from '../../project-data';

@Component({
  selector: 'app-developments-page',
  templateUrl: './developments-page.component.html',
})
export class DevelopmentsPageComponent {
  @Input({ required: true }) projects: Project[] = [];
  @Input({ required: true }) propertiesLoading = false;
  @Input({ required: true }) propertiesError = false;
  @Output() readonly inquiryRequested = new EventEmitter<void>();
  @Output() readonly projectSelected = new EventEmitter<ProjectSlug>();

  protected selectProject(event: Event, slug: ProjectSlug): void {
    event.preventDefault();
    this.projectSelected.emit(slug);
  }

  protected useFallbackImage(event: Event, fallbackSrc?: string): void {
    const image = event.target as HTMLImageElement | null;

    if (!image || !fallbackSrc || image.getAttribute('src') === fallbackSrc) {
      return;
    }

    image.src = fallbackSrc;
  }
}
